import { dedupePresetSigners } from '../../presetSignerDedup';

export {
  buildDirectorsSignersJson,
  buildMembersSignersJson,
} from '../../allotment-shares/composables/allotmentSigners';

function trim(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

function toSignerJson(
  items: Array<{ name: string; email?: string; role?: string }>,
): string {
  const list = dedupePresetSigners(items);
  return list.length > 0 ? JSON.stringify(list) : '';
}

export function buildRequestingDirectorSignerJson(input: {
  directorName: string;
  directorEmail?: string;
}): string {
  const name = trim(input.directorName);
  if (!name) return '';
  return toSignerJson([{ name, email: trim(input.directorEmail), role: 'director' }]);
}

export function buildTransferorSignerJson(input: {
  categoryCd: string;
  transferorName: string;
  representativeName?: string;
}): string {
  const isCorporate = trim(input.categoryCd) === 'B09001';
  const name = isCorporate
    ? trim(input.representativeName) || trim(input.transferorName)
    : trim(input.transferorName);
  if (!name) return '';
  return toSignerJson([{ name, role: 'signer' }]);
}

export function buildTransfereeSignerJson(input: {
  categoryCd: string;
  transfereeName: string;
  representativeName?: string;
}): string {
  const isCorporate = trim(input.categoryCd) === 'B09001';
  const name = isCorporate
    ? trim(input.representativeName) || trim(input.transfereeName)
    : trim(input.transfereeName);
  if (!name) return '';
  return toSignerJson([{ name, role: 'signer' }]);
}
